import { CreateWorkspaceProps, IWorkspace } from 'src/@types/workspace';
import { IWorkspaceInfo } from 'src/@types/workspace-info';
import { axios } from 'src/utils/axios';
import { LoginResponse } from './user';

export type CreateWorkspaceResponse = {
  workspace: IWorkspace;
  accessTokens?: LoginResponse;
  newUser: { _id: string };
};
export async function createWorkspace(
  payload: CreateWorkspaceProps,
): Promise<CreateWorkspaceResponse> {
  const { data } = await axios.post<CreateWorkspaceResponse>(
    '/workspace/create',
    payload,
  );
  return data;
}

export async function updateWorkspace({
  name,
  picture,
  featureSettings,
}: Pick<IWorkspace, 'name' | 'picture' | 'featureSettings'>): Promise<void> {
  const { data } = await axios.put<void>('/workspace/update', {
    name,
    picture,
    featureSettings,
  });
  return data;
}

export async function joinWorkspaceByInvite(
  workspaceInvite: string,
): Promise<Omit<CreateWorkspaceResponse, 'workspace'>> {
  const { data } = await axios.post('/workspace/invite/join', {
    workspaceInvite,
  });
  return data;
}

export async function getWorkspaceInfo(): Promise<IWorkspaceInfo> {
  const { data } = await axios.get<IWorkspaceInfo>('/workspace/info');
  return data;
}

export async function getInviteUrl(): Promise<{ url: string }> {
  const { data } = await axios.post<{ url: string }>('/workspace/invite/url');
  return data;
}

export async function resetInviteUrl(): Promise<{ url: string }> {
  const { data } = await axios.post<{ url: string }>(
    '/workspace/invite/url?refresh=true',
  );
  return data;
}

export async function deleteWorkspace() {
  const { data } = await axios.delete<{ _id: string; workspace: string }>(
    '/workspace/delete',
  );
  return data;
}

export async function leaveWorkspace() {
  const { data } = await axios.delete<{ _id: string; workspace: string }>(
    '/workspace/leave',
  );
  return data;
}

export async function inviteEmails(emails: string[]): Promise<IWorkspaceInfo> {
  const { data } = await axios.post<IWorkspaceInfo>('/workspace/invite', {
    emails,
  });
  return data;
}

export * as WorkspaceRequests from './workspace.requests';
